import { createActionGroup } from '@ngrx/store';

export const ValeurComposantActions = createActionGroup({
  source: 'Valeur Composant',
  events: {}
});
